import React from "react";
import { Flame, HandCoins, BookOpenText } from "lucide-react";

const AboutPage = () => {
  const scrollToAbout = () => {
    document.getElementById("about-sri-kalikamundeshwari")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="animate-fadeIn py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16 animate-slideUp">
          <div className="text-left">
            <h1 className="text-4xl font-bold mb-4 text-gray-800">
              About Sri Kalikamundeshwari Temple
            </h1>

            <p className="text-xl text-gray-600 max-w-3xl">
              A sacred sanctuary dedicated to spiritual growth, community
              service, and divine worship for over 30+ years.
            </p>

            <button
              onClick={scrollToAbout}
              className="mt-8 rounded-full bg-gradient-to-r from-orange-500 to-red-600 px-8 py-3 text-sm font-bold text-white shadow-lg hover:opacity-90 transition"
            >
              Read More →
            </button>
          </div>

          <div className="relative rounded-3xl overflow-hidden shadow-xl">
            <img
              src="/images/img59.jpeg"
              alt="Sri Kalikamundeshwari goddess"
              className="w-full h-[420px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 text-center text-white">
              <div className="text-base font-bold uppercase tracking-wide">
                Divine Presence
              </div>
              <div className="text-sm font-medium">
                A serene space for prayer and meditation
              </div>
            </div>
          </div>
        </div>

        {/* About Sri Kalikamundeshwari Section */}
        <div
          id="about-sri-kalikamundeshwari"
          className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 mb-8 animate-slideUp"
        >
          <h2 className="text-4xl font-bold text-center mb-8 text-orange-600 uppercase">
            ABOUT SRI KALIKAMUNDESHWARI
          </h2>

          <div className="text-gray-700 leading-8 text-justify">
            <p>
              The Sri Kalikamundeshwari (also spelled as Kalika Mundeshwari or
              Kalikamundeshwari Amma in some regions) is a powerful form of
              Goddess <b>Kali/ Raja Mathangi</b> , worshipped as a fierce yet
              protective mother goddess in South India. The name combines{" "}
              <b>Kali</b>, meaning the fierce destroyer of{" "}
              <b>evil, and Eshwari</b>, the supreme divine mother. In the sacred
              interpretation of the name, “<b>Ka</b>” represents creation,
              primal energy and manifestation, “<b>Li</b>” signifies dissolution
              and absorption back into the absolute, and “<b>Munda</b>” refers
              to the destroyer of ego and illusion. Together, the name
              symbolically represents the divine energy that creates, sustains,
              and ultimately dissolves the universe. Devotees believe she brings
              protection, courage, inner strength, and liberation from fear,
              negativity, and ignorance. Widely worshipped in Tamil Nadu and
              Karnataka, Sri Kalikamundeshwari is revered as a compassionate yet
              powerful form of Shakti, the divine feminine energy. She is often
              depicted with a fierce expression, weapons, and symbolic elements
              such as the trident, skull, veena, and the victorious stance over
              demonic forces, signifying the destruction of evil and the
              restoration of divine order. Her worship is especially significant
              during Amavasya, Friday poojas, and major festival days such as
              Navaratri and temple jatras, where devotees seek her grace,
              blessings, and spiritual strength.
            </p>
          </div>
        </div>

        {/* Our History Section */}
        <div
          id="our-history"
          className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 mb-16 animate-slideUp"
        >
          <h2 className="text-4xl font-bold text-center mb-12 text-orange-600">
            Our History
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 text-gray-700 leading-8 text-justify">
            {/* Left Column */}
            <div className="space-y-3">
              <p>
                The Sri KaliKamundeshwari Temple located near Nanjapuram – T.V.S
                Main Road Hosur, what started off as a small temple in 1993
                dedicated to Maa Kali, the idea all started due to a divine
                voice received from Sri Maha Ganapathi in the dreams of Late Sri
                D. Kaliappan Ex-Servicemen when he was serving in Army, in the
                dreams the God took a vow from Sri Kaliappan that he will live
                his first son in the service of divinity and spirituality and he
                should take up to construct temple for Maa Kali & Sri Raja
                Mathangi at appropriate time and at a dedicated place. As per
                the divine wish now it has blossomed into a sacred temple in the
                southwest part of Hosur, also called Rudra Gaya near T.V.S
                Motors Company.
              </p>
              <p>
                The initial construction of the temple started in the year 2003
                and completed with great difficulties in the year 2010 in the
                site donated by Sri D. Kaliappan & Smt. Bhagyavathi. The first
                Kumbha Abhishekam was performed on 26th of June in the year 2010
                by the Temple Trust successfully, from that date daily pooja and
                yearly festivals are celebrated in the temple without fail,
                which includes 5 to 9 days Aadi festival starting with Flag
                Hosting and Karga Mahotsva followed by Devi procession.
              </p>
            </div>

            {/* Right Column */}
            <div className="space-y-11">
              <p>
                Now as per the Devi’s orders it has been planned to re-construct
                ( Punar Nirmana ) and redefine the temple structures in the
                additional land procured by Sri Thirumurthi swamigal & Family
                for this reason. It is planned to construct a Maha Mantapan &
                Entrance Gopuram with Maha Duwara. Separate Sannidi’s with
                Kalasa Gopuram for Sri Maha Ganapathi, Sri Valli Devanai sametha
                Sri Subramanya Swamy, Sri Dakshineswara (Lord Shiva) , Sri
                Yellan Kali Amman, Sri Yoga Munieshwara, Sri Periya Karuppu
                swamy & Sri Varahi sametha Unmatha Bhairva to be consecrated in
                the Pathala Dhyana Mantappa along with Saptha Matha’s.
              </p>
              <p>
                Appeal: As per the divine orders of Sri KaliKamundeshwari , we
                have made every effort to complete the renovation as quickly as
                possible and to perform the 2nd Kumba Ahishekam at the earliest,
                On behalf of the Trust we kindly request all the devotees to
                participate in the renovation & re-construction of temple as
                scheduled above by donating as much as possible material or
                monetary support.
              </p>
              <p className="font-bold">
                Sri Kalikamundeshwari Temple Trust® Trustees & Committee Members
              </p>
            </div>
          </div>
        </div>

        {/* Core Values Section */}
        <div className="bg-gray-50 p-8 rounded-2xl animate-slideUp">
          <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">
            Our Core Values
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: "Devotion",
                icon: Flame,
                desc: "Deep spiritual connection and unwavering faith.",
              },
              {
                title: "Service",
                icon: HandCoins,
                desc: "Selfless service to community and humanity.",
              },
              {
                title: "Wisdom",
                icon: BookOpenText,
                desc: "Ancient knowledge for modern spiritual growth.",
              },
            ].map((value, index) => {
              const Icon = value.icon;
              return (
                <div
                  key={index}
                  className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
                >
                  <div className="mb-4 flex justify-center">
                    <Icon
                      className="h-12 w-12 text-orange-600"
                      strokeWidth={1.8}
                    />
                  </div>

                  <h3 className="text-xl font-semibold mb-3 text-orange-600">
                    {value.title}
                  </h3>

                  <p className="text-gray-600 leading-7">{value.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
